
export const PLAYER_SELECTED = 'PLAYER_SELECTED'
export const PLAYER_TWO_SELECTED = 'PLAYER_TWO_SELECTED'
export const PLAYER_RESETTED = 'PLAYER_RESETTED'

export const selected = (state = [], action) => {
    switch (action.type) {
        case PLAYER_SELECTED:
            var ss = {
                ...state,
            }
            ss.selected = action.username
            return ss   

        case PLAYER_TWO_SELECTED:
            var ss = {
                ...state,
            }
            ss.selected2 = action.username
            return ss   
    
            case PLAYER_RESETTED:
            var ss = {
                ...state,
            }
            ss.selected = undefined
            ss.selected2 = undefined
        return ss   
    
        default:
            return state
    }
}

export const playerSelected = ({username}) => {
    return { type: PLAYER_SELECTED, username:username}
}

export const playerTwoSelected = ({username}) => {
    return { type: PLAYER_TWO_SELECTED, username:username}
}

export const playerResetted = () => {
    return { type: PLAYER_RESETTED}
}



// WEBPACK FOOTER //
// ./src/reducers/selected/index.js